import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AccessibilityProvider } from './components/Accessibility/AccessibilityProvider';
import { ProgressProvider } from './context/ProgressContext';
import AppRoutes from './routes/AppRoutes';
import './styles/tailwind.css';
const App = () => {
  return (
    <ProgressProvider>
      <AccessibilityProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AccessibilityProvider>
    </ProgressProvider>
  );
};

export default App;
